import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-surface",
  id: "global-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-h4 text-primary-lighten-1" }, "Not Authorized", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-primary-lighten-2 text-body" }, " You are not authorized to access this app. ", -1)),
        _createVNode(_component_v_btn, {
          "prepend-icon": "mdi-login",
          color: "primary",
          variant: "tonal",
          to: { name: 'login' }
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" go to login ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}